import _isEqual from 'lodash/isEqual'

import { RESET_WIZARD, TOGGLE_TRAINING_VIDEO } from '../constants'

import {
  CREATE_CUSTOM_TRAINING_ASYNC,
  FETCH_TRAINING_VIDEOS_ASYNC,
  LANGUAGE_FILTER_CHANGE,
  SEASON_FILTER_CHANGE,
  SET_IS_VISITED,
  SHOW_SUBTITLE_CONTENT_CHANGE,
  SOURCE_FILTER_CHANGE,
  SOURCE_VALUES,
  TYPE_FILTER_CHANGE,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    videosByVendor: {},
    prevSourceFilter: null,
    sourceFilter: [SOURCE_VALUES.IRONSCALES],
    seasonFilter: null,
    languagesFilter: [],
    typeFilter: null,
    showSubtitleContent: true,
    defaultTrainingVideoApplied: false,
    isVisited: false,
    isCustomTrainingCreating: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TRAINING_VIDEOS_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          loader: !state.videosByVendor[action.payload.vendor],
        }
      case FETCH_TRAINING_VIDEOS_ASYNC.SUCCESS: {
        // Each vendor keeps its own list; the selector picks the visible union.
        return {
          ...state,
          error: null,
          loader: false,
          videosByVendor: {
            ...state.videosByVendor,
            [action.payload.vendor]: action.payload.data.items || [],
          },
          meta: action.payload.data.meta || state.meta,
        }
      }
      case FETCH_TRAINING_VIDEOS_ASYNC.ERROR:
        return {
          ...state,
          error: null,
          loader: false,
        }
      case TOGGLE_TRAINING_VIDEO:
        return {
          ...state,
          defaultTrainingVideoApplied: true,
        }
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case SEASON_FILTER_CHANGE: {
        return {
          ...state,
          seasonFilter: action.payload.value,
        }
      }
      case LANGUAGE_FILTER_CHANGE: {
        return {
          ...state,
          languagesFilter: action.payload.value,
        }
      }
      case TYPE_FILTER_CHANGE: {
        return {
          ...state,
          typeFilter: action.payload.value,
        }
      }
      case SHOW_SUBTITLE_CONTENT_CHANGE: {
        return {
          ...state,
          showSubtitleContent: action.payload.value,
        }
      }
      case SOURCE_FILTER_CHANGE: {
        // Callers pass one vendor or a list; the state always holds a list.
        const next = [action.payload.sourceFilter].flat().filter((id) => id != null)

        if (_isEqual(state.sourceFilter, next)) return state

        return { ...state, prevSourceFilter: state.sourceFilter, sourceFilter: next }
      }
      case SET_IS_VISITED: {
        return {
          ...state,
          isVisited: action.payload.value,
        }
      }
      case CREATE_CUSTOM_TRAINING_ASYNC.INITIATE:
        return {
          ...state,
          isCustomTrainingCreating: true,
        }
      case CREATE_CUSTOM_TRAINING_ASYNC.SUCCESS:
      case CREATE_CUSTOM_TRAINING_ASYNC.ERROR:
        return {
          ...state,
          isCustomTrainingCreating: false,
        }
      default:
        return state
    }
  }
}
